import { Injectable } from '@angular/core';
import { Headers, Http } from '@angular/http';
import { HttpClient, HttpHeaders, HttpParams, HttpErrorResponse, HttpXhrBackend } from "@angular/common/http";
import { BehaviorSubject, Subject, Observable, of } from 'rxjs';
import { map, switchMap, catchError, mergeMap, tap, retry } from 'rxjs/operators';
import { LocalDataSource } from 'ng2-smart-table';

//import { MessageService } from './message.service';

// import { Observable } from 'rxjs/Observable';
// import 'rxjs/add/operator/catch';
// import 'rxjs/add/observable/of';
// import 'rxjs/add/observable/empty';
// import 'rxjs/add/operator/retry'; // don't forget the imports


import { environment } from '../../environments/environment'
import Swal from 'sweetalert2';
import { instiLoading } from './instiLoading.module';

@Injectable({    
  providedIn: 'root'
})   
export class InstiService {
  private baseUrl: string = environment.base_url_api;
//  private baseUrl: string = 'http://api.natureza51.local/';
  private headers: Headers = new Headers({'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': 'http://localhost:58965'
  }); 
   private csr_token: string = ''; 
   private session_name:string ='';
   private session_id: string ='';
   private session_obj: any={};
   private authorization: string = '';
   private page_base_url='';
   private user_data:any=null;
  // const httpClient = new HttpClient(new HttpXhrBackend({ build: () => new XMLHttpRequest()}));

  getUrl(sufix){
      var token=sufix=='csr-xtoken'? '' : this.tokenOnUrl();
      return !sufix ? this.baseUrl+token : this.baseUrl+sufix+token;
  }
  private csr_xtoken: string = ''; 
  // =new HttpClient();
  //private httpClient: HttpClient,
  //  public message : MessageService    
         
  
    protected http: HttpClient
  constructor(
         
            ) { }
  
  private setCsrXtoken(){
      
  } 
  private  setCsrToken(value){ this.csr_token=value._token; }  
  private  setSessionObj(value){
          this.session_name=value.session_name;
          this.session_id=value.session_id;
          this.session_obj[this.session_name]=this.session_id;
  }
  private processDataUser(dados):InstiService{
      if(!this.hasUserData()){ return   this.setAuthorization(null); }
      var ud=dados;
      this.setAuthorization(ud.hasOwnProperty('api_authorizations')? ud.api_authorizations : null);      
  }
  private setUserData(value):InstiService{ 
    var d=!value ? {} : value;
    this.user_data=Object.keys(d).length==0? null : (d.hasOwnProperty('user_data') ? d.user_data : null);
    localStorage.setItem('insti_user_data', JSON.stringify(this.user_data)); 
    return this.processDataUser(d);
  }
  
  private setAuthorization(value):InstiService{ 
    this.authorization=value; 
    localStorage.setItem('insti_authorization', value);
    return this;
  }
  getCsrXtoken(){ return this.csr_xtoken;}  
  loadCsrToken(){
          var instance=this;
        var a=this.http.get(instance.getUrl('csr-xtoken'));
        a.subscribe(function(response){
                    instance.setCsrToken(response);
                    instance.setSessionObj(response);
                }, 
                function(error){
                    /**
                     * @TODO ALUISIO FERREIRA DE SOUSA 05/09/2019
                     *  Adicionar um HANDLE de erro
                     */
                    var b=error;
                });        
       return a;          
    }
    getAutorizationFromStorage(){
        var a=localStorage.getItem('insti_authorization');
        return a;
    }
    getAuthorization(){ 
         var b=this.authorization ? this.authorization : this.getAutorizationFromStorage();
        return b;
     }     
     getSessionObj(){ return this.session_obj;}
     getCsrToken(){ return this.csr_token; }
     hasCsrToken(){ return this.csr_token==''? false : true; }
     getHeadersAsArray(){
          var retorno={'X-CSRF-TOKEN':this.getCsrToken(),
                      'Authorization': 'Bearer '+this.getAuthorization(),
                      'Content-Type': 'application/json; charset=utf-8',
                      'InstCli': JSON.stringify(this.getClientInformation())
                      };
                      
            if(this.session_name!=''){
                retorno[this.session_name]=this.session_id;
            }            
          return retorno;          
     }
    //  headerInTerpolation(headersInstance, properties?){
    //      var headers=headersInstance;//headersInstance.clone();
    //      var prop=!properties ? this.getHeadersAsArray() : properties;
    //       var keys=Object.keys(prop);
    //      for(var x=0; x< keys.length; x++){
    //          var chave=keys[x];
    //          if(chave==''){ continue; }
    //         headers=headers.set(chave, prop[chave]);
    //      }
    //      return headers;                  
    //  }
    //  getHeaders(){  
    //      var retorno=this.getHeadersAsArray();          
    //      this.headers=this.headerInTerpolation(new HttpHeaders());
    //      return {'headers':  this.headers};
    //       //{headers: this.headers};  
    //  }
    headerInTerpolation(headersInstance, properties?){
        var headers=headersInstance;
        var prop=!properties ? this.getHeadersAsArray() : properties;
         var keys=Object.keys(prop);
        for(var x=0; x< keys.length; x++){
            var chave=keys[x];
            if(chave==''){ continue; }
            if(headers.has(chave)){
                headers.set(chave, prop[chave]);
            }
            else{
             headers=headers.append(chave, prop[chave]);
            }
        }
        return headers;  
        /*
        var headers=headersInstance;//headersInstance.clone();
        var prop=!properties ? this.getHeadersAsArray() : properties;
         var keys=Object.keys(prop);
        for(var x=0; x< keys.length; x++){
            var chave=keys[x];
            if(chave==''){ continue; }
           headers=headers.set(chave, prop[chave]);
        }
        return headers;
        */                        
   }
  
   getHeaders(){  
      let retorno=this.headerInTerpolation(new HttpHeaders());;          
       this.headers=retorno;
       return {'headers':  retorno};
   }
     getClientInformation(){
        var ci=clientInformation;
        var fields=['appCodeName','appName', 'appVersion','language',
                    'plataform','product','productSub','userAgent'];
        var retorno={};
        for(var x=0; x < fields.length; x++){
            var atual=fields[x];
            /*if(ci.hasOwnProperty(atual)===false){
                continue;
            } */           
            retorno[atual]=ci[atual];
        }
        return retorno;            
     }
     appendToken(dados){
         dados._token=this.getCsrToken();
         return dados; 
     } 
     tokenOnUrl(){  return '?_token='+this.getCsrToken();} 
     setPageUrlBase(url:string){
         this.page_base_url=url;
     }
     getPageUrlBase(){ return this.page_base_url;}
     getPageUrlFull(){ return this.getUrl(this.getPageUrlBase());}
    getPageUrlList(codTela?){ 
        if(!codTela){
            return this.getPageUrlBase()+'listar';
        }
        return this.getPageUrlBase()+'listar'+codTela;
    }
     getPageUrlAdd(){ return this.getPageUrlBase()+'/insert'}
     getPageUrlUpdate(){ return this.getPageUrlBase()+'/update'}
     getPageUrlDel(){ return this.getPageUrlBase()+'/delete'}
     getHomeUrl(with_prefix?){ return (with_prefix===true? '/': '')+environment.home_route;}
     getLoginUrl(with_prefix?){ return (with_prefix===true? '/': '')+environment.login_route;}
     getResetPasswordUrl(with_prefix?){ return (with_prefix===true? '/': '')+environment.reset_password_route;}
     getLogoutUrl(with_prefix?){ return (with_prefix===true? '/': '')+environment.logout_route;}
     getUserDataFromStorage(){
        var a=JSON.parse(localStorage.getItem('insti_user_data')); 
        return a;
     }
     getUserData(){ 
         var c= this.user_data ? this.user_data : this.getUserDataFromStorage() ;
        return c;
     }
     hasUserData():boolean{
         let d=this.getUserData();
         if(!d){ return false;}
         return Object.keys(d).length==0? false : true;
     }
     isLogged():boolean{ return this.hasUserData();}
     
     /***
      * @TODO ALUISIO FERREIRA DE SOUSA 09/09/2019
      * No momento estou considerando apenas os metodos GET e POST
      * @param url_sufix string Obrigatorio
      * @param metodo STRING Obrigatorio, valroes aceitos get, post
      * @param success_call_back FUNCTION Opcional função de callback quando ok,
      * @param error_call_back FUNCTION opcional função de callback quando tem erro.
      * @param form_data Object opcional dados a serem enviados ao servidor
      *  @param model 
      */
     doHttp(url_sufix:string, metodo:string, success_call_back?, error_call_back?, form_data?, model?, is_external?){
        
        if(this.http !== undefined){
            var instance=this;        
            var obj_model=!model? {} : model; 
            var erro_call="";
            var method_name=["get", "post"].indexOf(metodo)<0? "get": metodo;
            var url=is_external===true ? url_sufix : instance.getUrl(url_sufix)
            var methodType={'get':function(){ return  instance.http.get(url,  instance.getHeaders()); },

                            'post':function(){ return instance.http.post(url, form_data, instance.getHeaders());}
                            };
            var http_objt=methodType[method_name]();
           

            
            
            http_objt.subscribe(
                (response)=>{
                    return (typeof success_call_back !=='function') ? null : success_call_back(response)
                },
                (error)=>{
                   return (typeof error_call_back !=='function') ? null: error_call_back(error)
                });                
                
            return http_objt.pipe(
                  //retry(1),
                  // tap((newCargo: Cargo) => this.log(`added login w/ ${newCargo}`)),
                  catchError(function(error){
                       return (typeof error_call_back !=='function') ? null: error_call_back(error);
                  })
                );
        }      
     }
     /**
      * matrix_retorno ARRAY Obrigatorio
      * sucess_func FUNCTION opcional
      * error_func FUNCTION opcional
      */
     listar(matrix_retorno, sucess_func?, error_func?, url_listar?, codTela?){
         var call_error=(typeof error_func !=='function') ? function(error){
         }: error_func; 
         var call_success=function(response){
             !matrix_retorno? null : matrix_retorno.load(response);
            return (typeof sucess_func !=='function') ?  null :  sucess_func(response);
         } 
        codTela = !(codTela) ? '' : '/'+codTela;
        var instance=this; 
        var url = !url_listar ? instance.getPageUrlList(codTela) : url_listar; 
        return this.doHttp(url, 'get', call_success, call_error, null, null);
    }
     adicionar(form_data, sucess_func?, error_func?){
         var call_error=(typeof error_func !=='function')? function(error){
         }: error_func; 
         var call_success=function(response){
            return (typeof sucess_func !=='function') ?  null : sucess_func(response);
         } 
        var instance=this; 
        return this.doHttp(instance.getPageUrlAdd(), 'post', call_success, call_error, form_data, null);
     }
     editar(form_data, sucess_func?, error_func?){
         var call_error=(typeof error_func !=='function')? function(error){
         }: error_func; 
         var call_success=function(response){
            return (typeof sucess_func !=='function') ?  null : sucess_func(response);
         } 
        var instance=this; 
        return this.doHttp(instance.getPageUrlUpdate(), 'post', call_success, call_error, form_data, null);
     }
     deletar(form_data, sucess_func?, error_func?){
         var call_error=(typeof error_func !=='function')? function(error){
            
         }: error_func; 
         var call_success=function(response){
            return (typeof sucess_func !=='function') ?  null : sucess_func(response);
         } 
        var instance=this; 
        return this.doHttp(instance.getPageUrlDel(), 'post', call_success, call_error, form_data, null);
     }     
     logar(dados, sucess_func?, erro_func?){
        var instance=this;
        this.setUserData(null)
        .doHttp('logar','post',
             function(response){
               instance.setUserData(response.hasOwnProperty('dados')? response.dados : null);                      
               return (typeof sucess_func !=='function') ?  null : sucess_func(response);
               }, 
           function(error){
                instance.showAlert("Atenção!", error.error.msg, 'warning');
               return (typeof erro_func !=='function') ?  null : erro_func(error);
           }, 
        dados);
    }

     logout(){
         var instance=this;
         this.doHttp('logout','post',function(response){
              instance.setUserData(null);
         });          
     }
     showAlert(titulo, mensagem, tipo, showCancel=false,call_back?, confirmText = 'OK', cancelText = 'Cancelar', p_width='32rem'){
        Swal.fire({ 
          title: titulo,
          html:mensagem,
          type: tipo,
          showCancelButton: showCancel,
          showConfirmButton: true,
          cancelButtonText: cancelText,
          confirmButtonText: confirmText,
          width: p_width,
          heightAuto: false
          
        }).then(call_back);  
      }
     ajusteURL(){
        if(this.getPageUrlBase().indexOf('/')>-1){//
            return this.getPageUrlBase().substr(0, this.getPageUrlBase().length-1)
        }

        return this.getPageUrlBase();
     }

     importarExcel(form_data, tbl_name, tipo_table, periodo = null, success, error?){
        let instance = this; 
        return instance.doHttp(`importar/${tbl_name}/insert`,'post',success,error,form_data);
     }

     getUrlExport(){
        return environment.export_route;
    }

    aprovarTodas(param, success, error) {
      return this.doHttp(`orcamento/lotacao/aprovarTodas`,'post', success, error, param);       
    }

    
}
